export function getTitle(value: string) {
  return `${value} - My-Serious-Game`
}
